<script setup lang="ts">
/**
 * `<ClientOnly>` shim for the Vite + Vue 3 frontend.
 *
 * Background: this codebase ships a Vite SPA (apps/frontend), not a Nuxt
 * app. The Nuxt-specific `<ClientOnly>` component is therefore not
 * available — but it leaks into our code through copy-pasted snippets
 * (e.g. `CompanySelector.vue:73`, which wraps the active-company
 * `UDropdownMenu` so the menu doesn't render on the SSR pass). Without
 * this stub Vue emits
 *   [Vue warn] Failed to resolve component: ClientOnly
 * and the dropdown never mounts.
 *
 * In a Vite SPA there is no SSR pass, so we can simply render the
 * default slot. Keeping the explicit component (vs. removing the
 * wrapper) preserves the documented intent — "render on the client
 * only" — so a future migration to Nuxt stays drop-in.
 */
</script>

<template>
  <slot />
</template>
